"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticate = void 0;
var _BPMpi = require("./BP.Mpi.3ds20");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const _createHiddenElementWithClass = className => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.classList.add(className);
  document.getElementsByTagName('body')[0].appendChild(input);
  return input;
};
/**
 * O javascript da Cielo lê parâmetros com document.getElementsByClassName(fieldName)[0].value
 * @param fieldName
 * @param value
 */
const _setParam = (fieldName, value) => {
  const input = document.getElementsByClassName(fieldName)[0] || _createHiddenElementWithClass(fieldName);
  input.value = value;
};
class Cielo3dsError extends Error {
  constructor(p, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    _defineProperty(this, "Xid", void 0);
    _defineProperty(this, "Eci", void 0);
    _defineProperty(this, "Version", void 0);
    _defineProperty(this, "ReferenceId", void 0);
    _defineProperty(this, "failure", void 0);
    _defineProperty(this, "returnCode", void 0);
    _defineProperty(this, "returnMessage", void 0);
    _defineProperty(this, "errorType", void 0);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Cielo3dsError);
    }
    this.name = 'Cielo3dsError';
    if (p) {
      Object.assign(this, p);
    }
  }
}
const authenticate = async p => {
  const {
    accessToken,
    environment,
    installments,
    paymentMethod,
    cardNumber,
    cardExpiryDate,
    orderNumber,
    currency,
    totalValue,
    merchantUrl
    // deviceIpAddress,
  } = p;
  _setParam('bpmpi_auth', true);
  _setParam('bpmpi_auth_notifyonly', false);
  _setParam('bpmpi_auth_suppresschallenge', false);
  _setParam('bpmpi_accesstoken', accessToken);
  _setParam('bpmpi_installments', installments);
  _setParam('bpmpi_paymentmethod', paymentMethod);
  _setParam('bpmpi_cardnumber', cardNumber);
  _setParam('bpmpi_cardexpirationmonth', cardExpiryDate.substring(0, 2));
  _setParam('bpmpi_cardexpirationyear', '20' + cardExpiryDate.substring(2));
  _setParam('bpmpi_ordernumber', orderNumber);
  _setParam('bpmpi_currency', currency);
  _setParam('bpmpi_totalamount', Math.round((totalValue || 0) * 100));
  _setParam('bpmpi_order_productcode', 'PHY');
  _setParam('bpmpi_merchant_url', merchantUrl);
  _setParam('bpmpi_device_channel', 'Browser');
  // _setParam('bpmpi_device_ipaddress', deviceIpAddress)

  const bp = (0, _BPMpi.BP)();
  let successCallback;
  let onFailureCallback;
  let onUnenrolledCallback;
  let onDisabledCallback;
  let onErrorCallback;
  let onUnsupportedBrandCallback;
  await new Promise((res1, rej1) => {
    const config = {
      onReady: function () {
        // Evento indicando quando a inicialização do script terminou.
        res1();
      },
      onSuccess: function (e) {
        var _successCallback;
        // Cartão elegível para autenticação, e portador autenticou com sucesso.
        (_successCallback = successCallback) === null || _successCallback === void 0 ? void 0 : _successCallback(e);
      },
      onFailure: function (e) {
        var _onFailureCallback;
        // Cartão elegível para autenticação, porém o portador finalizou com falha.
        (_onFailureCallback = onFailureCallback) === null || _onFailureCallback === void 0 ? void 0 : _onFailureCallback(e);
      },
      onUnenrolled: function (e) {
        var _onUnenrolledCallback;
        // Cartão não elegível para autenticação (não autenticável).
        (_onUnenrolledCallback = onUnenrolledCallback) === null || _onUnenrolledCallback === void 0 ? void 0 : _onUnenrolledCallback(e);
      },
      onDisabled: function () {
        var _onDisabledCallback;
        // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
        (_onDisabledCallback = onDisabledCallback) === null || _onDisabledCallback === void 0 ? void 0 : _onDisabledCallback();
      },
      onError: function (e) {
        var _onErrorCallback;
        // Erro no processo de autenticação.
        (_onErrorCallback = onErrorCallback) === null || _onErrorCallback === void 0 ? void 0 : _onErrorCallback(e);
      },
      onUnsupportedBrand: function (e) {
        var _onUnsupportedBrandCa;
        // Bandeira não suportada para autenticação.
        (_onUnsupportedBrandCa = onUnsupportedBrandCallback) === null || _onUnsupportedBrandCa === void 0 ? void 0 : _onUnsupportedBrandCa(e);
      },
      Environment: environment,
      Debug: process.env.NODE_ENV === 'development'
    };
    global['bpmpi_config'] = () => config;
    bp.Mpi.load();
  });
  return new Promise((res, rej) => {
    successCallback = e => {
      res({
        Cavv: e.Cavv,
        Xid: e.Xid,
        Eci: e.Eci,
        Version: e.Version,
        ReferenceId: e.ReferenceId
      });
    };
    onUnenrolledCallback = e => {
      rej(new Cielo3dsError({
        Xid: e.Xid,
        Eci: e.Eci,
        Version: e.Version,
        ReferenceId: e.ReferenceId,
        errorType: 'AuthenticationNotPossible'
      }, 'Cartão não suportado'));
    };
    onFailureCallback = e => {
      rej(new Cielo3dsError({
        Xid: e.Xid,
        Eci: e.Eci,
        Version: e.Version,
        ReferenceId: e.ReferenceId,
        errorType: 'AuthenticationFailure'
      }, 'Falha na validação de segurança do cartão'));
    };
    onErrorCallback = e => rej(new Cielo3dsError({
      Xid: e.Xid,
      Eci: e.Eci,
      Version: e.Version,
      ReferenceId: e.ReferenceId,
      returnMessage: e.ReturnMessage,
      returnCode: e.ReturnCode,
      errorType: 'Error'
    }, 'Erro na validação de segurança do cartão: ' + e.ReturnMessage));
    onDisabledCallback = () => rej(new Error('erro na configuração - "bpmpi_auth" false'));
    onUnsupportedBrandCallback = e => rej(new Cielo3dsError({
      Xid: e.Xid,
      Eci: e.Eci,
      Version: e.Version,
      ReferenceId: e.ReferenceId,
      returnMessage: e.ReturnMessage,
      returnCode: e.ReturnCode,
      errorType: 'AuthenticationNotPossible'
    }, 'Bandeira do cartão não suportada'));
    bp.Mpi.authenticate();
  });
};
exports.authenticate = authenticate;